import { Testimonial } from '../types/landing';

export const testimonials: Testimonial[] = [
  // {
  //   quote: "Tumblr lomo banh mi taxidermy hella street art. 90's bitters quinoa, wolf gluten-free snackwave portland slow-carb hexagon readymade.",
  //   name: 'Josh Otero',
  //   title: 'Co-Founder & CEO @ Elanah.ai',
  //   credential: '',
  //   avatar: 'https://ca.slack-edge.com/T07T3SKSVSB-U07TX3UC1LZ-cf2e07ceb73e-512',
  // },
  {
    quote: "I want to stay informed, but I struggle with moderation. It seemed like my only options were to abstain from news entirely, or constantly get sucked into the rabbit hole of doomscrolling. With filtrd I've finally found a solution to this difficult optimization problem.",
    name: 'Austin Wood',
    title: 'Founder & CEO @ Fractal Labs',
    credential: '',
    avatar: 'https://ca.slack-edge.com/TC0HM6B1N-UC1DC1QTF-d74a9247d953-512',
  },
];
